module.exports = "/_next/static/images/google-play-icon-6374bacc1460475a7c440966cf11163d.png.webp";